import {Component, OnInit} from '@angular/core';
import {UserService, BackendStatus} from '../user.service';

@Component({
  selector: 'app-page-footer',
  templateUrl: './page-footer.component.html',
  styleUrls: ['./page-footer.component.css']
})
export class PageFooterComponent implements OnInit {

  /**
   * current year
   */
  year: number;

  backendStatus: String;

  constructor(private userService: UserService) {
    this.year = (new Date()).getFullYear();
  }

  ngOnInit() {
    this.userService.getBackendStatus();
    this.userService.backendStatus.subscribe((backendStatus: BackendStatus) => {
      console.log(`Received BackendStatus: ${backendStatus}`);
      if (backendStatus === null) {
        this.backendStatus = 'Erro ao comunicar com o Backend';
      } else {
        if (backendStatus.status !== 200) {
          this.backendStatus = `Erro de status do Backend:${backendStatus.status}`;
        } else {
          this.backendStatus = `${backendStatus.appName} ${backendStatus.version}`;
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/page-footer/page-footer.component.ts